/**
 * @file default.component.tsx
 * @description Компонент стандартной страницы ошибки 404, который обрабатывает неопределённые маршруты и обеспечивает 
 * навигацию пользователя обратно в приложение. Включает чистый интерфейс ошибки 404 с использованием 
 * дизайн-системы Consta UI с выразительной кнопкой для перенаправления пользователей на главную страницу. 
 * Интегрируется с системой очереди модальных окон для правильного управления состоянием и обеспечивает 
 * удобный для пользователя опыт обработки ошибок.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@hooks/use-modals', '@consta/uikit/Responses404', '@components/ui/base/button', 'react-router-dom']
 * @related-files ['@hooks/use-modals/index.tsx']
 */

import { useModalQueue } from '@hooks/use-modals';
import { Responses404 } from '@consta/uikit/Responses404';
import { Button } from '@components/ui/base/button';
import { useNavigate } from 'react-router-dom';

export const Default = () => {
    const navigate = useNavigate();
    const closeModalHandler = useModalQueue(() => navigate(import.meta.env.VITE_BASE_URL));

    return (
        <Responses404
            className="h-full"
            actions={<Button onClick={() => closeModalHandler()} size="m" view="ghost" label="На главную" />}
        />
    );
};
